/* eslint-disable import/no-extraneous-dependencies */
import {
  Module,
  VuexModule,
  Mutation,
} from 'vuex-module-decorators';
import { CancelTokenSource } from 'axios';

@Module({
  namespaced: true,
  name: 'http',
})
export default class extends VuexModule {
  cancelTokens: CancelTokenSource[] = [];

  get tokens() {
    return this.cancelTokens;
  }

  @Mutation
  public addCancelToken(token: CancelTokenSource) {
    this.cancelTokens.push(token);
  }

  @Mutation
  public clearCancelTokens() {
    this.cancelTokens = [];
  }

  @Mutation
  public cancelPendingRequests() {
    this.cancelTokens.forEach((request: CancelTokenSource) => {
      if (request.cancel) {
        request.cancel();
      }
    });

    this.cancelTokens = [];
  }
}
